import React from 'react';
import { Link } from 'react-router-dom';
import { SiteNavLinks } from '../components/SiteNavLinks';
export function Tour() {
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-279" data-mp="2h8jw3qhl7drb">
      {/* Header — matches the other pages */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-280" data-mp="34ymjvuegxxk4">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-281" data-mp="300ckf7lpoasp">
          lennon cripe
        </Link>

        <SiteNavLinks data-id="element-282" data-mp="2vy7tigmnds9r" />

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-283" data-mp="2vxg0ndkfq8n6">
          contact
        </a>
      </header>

      {/* Tour content */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-284" data-mp="1kklxcbideqeq">
        <p className="lowercase" data-id="element-285" data-mp="1fkhnh4bywtxh">no upcoming shows</p>
      </section>
    </main>;
}